// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"209":"component---src-templates-dumpsters-kpp-pages-js","684":"cada2cc6","774":"framework"}[chunkId] || chunkId) + "-" + {"209":"d850ee928279f1095636","589":"e5755b5cf428fee68086","684":"a762a33809f814c2f84c","696":"32da1eda352948543f0c","774":"64fb867057913ead4b67"}[chunkId] + ".js";
};